/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited
// @ts-nocheck


import { DEFAULT_SIZE, type IconProps } from '../../npmlib-icons/src/types';


export const IosBack = ({ color = 'currentColor', size = DEFAULT_SIZE, ...props }: IconProps) => {
        return (
                <svg
                    width={size}
                    height={size}
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    {...props}>
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M15.9361 2.5L17 3.55728L8.50456 12L17 20.4427L15.9361 21.5L7.44068 13.0573C6.85311 12.4734 6.85311 11.5266 7.44068 10.9427L15.9361 2.5Z"
                        fill={color}
                    />
                </svg>
        );
    };
